import { render, staticRenderFns } from "./CategoriesForm.vue?vue&type=template&id=4b789e68&scoped=true&"
import script from "./CategoriesForm.vue?vue&type=script&lang=js&"
export * from "./CategoriesForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesForm.vue?vue&type=style&index=0&id=4b789e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b789e68",
  null
  
)

export default component.exports